export const storeTranslations = (context) => (type, id) => ({
    type: "CMS.TRANSLATIONS.STORE",
    payload: {
        type,
        id,
    },
    context,
});
